<template>
	<div class="wrap_spaced">
		<button
			v-for="(item, idx) in props.items"
			:key="idx"
			class="c_button"
			:class="(item === $route.query.sub || (idx === 0 && !$route.query.sub)) && 'selected'"
			@click="onClickTab(item)"
		>
			{{ item }}
		</button>
	</div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const props = defineProps<{
	items: string[];
}>();
const emit = defineEmits(['update:category']);

const onClickTab = (item: string) => {
	emit('update:category', item);
	router.replace({ query: { ...route.query, sub: item } });
};
</script>

<style scoped lang="scss">
.wrap_spaced {
	display: flex;
	gap: 1rem;
	overflow-x: auto;
}
.wrap_spaced::-webkit-scrollbar {
	height: 0rem;
}
button {
	height: auto;
	padding: 1.3rem 1.6rem;
	gap: 1rem;
	border-radius: 6px;
	border: 1px solid var(--color-base-mid);
	font-size: var(--font-s-mid);
	font-weight: var(--font-w-semi-bold);
	line-height: normal;
}
.selected {
	color: var(--color-primary);
	border: 1px solid var(--color-primary);
}
</style>
